import { render, staticRenderFns } from "./SingaporeContent.vue?vue&type=template&id=751a57b0&scoped=true&"
import script from "./SingaporeContent.vue?vue&type=script&lang=js&"
export * from "./SingaporeContent.vue?vue&type=script&lang=js&"
import style0 from "./SingaporeContent.vue?vue&type=style&index=0&id=751a57b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751a57b0",
  null
  
)

export default component.exports